import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import palette from "../../common/styles/palette";

/** Somente **texto** recebe negrito; o restante continua como texto React. */
export const renderTextoComNegrito = (texto: string): React.ReactNode =>
  texto.split(/(\*\*[\s\S]+?\*\*)/g).map((parte, indice) =>
    indice % 2 === 1 ? <strong key={indice}>{parte.slice(2, -2)}</strong> : parte
  );

const formatos = {
  pdf: { Icone: PictureAsPdfOutlinedIcon, rotulo: "PDF", cor: palette.dangerText },
  docx: { Icone: DescriptionOutlinedIcon, rotulo: "Word", cor: palette.info },
  xlsx: { Icone: GridOnOutlinedIcon, rotulo: "Excel", cor: palette.emeraldDeep },
  csv: { Icone: TableChartOutlinedIcon, rotulo: "CSV", cor: palette.emeraldDeep },
};

/** Formata o recibo textual existente sem mudar o contrato ou o histórico salvo. */
export default function mensagemArquivos(texto: string): React.ReactNode {
  const recibo = /(?:^|\n)Arquivos enviados: ([\s\S]+)$/.exec(texto);
  if (!recibo) return undefined;
  // A vírgula dentro de um nome continua fazendo parte dele.
  const nomes: string[] = [];
  const arquivos = /([\s\S]+?\.(?:pdf|docx|xlsx|csv))(?:, |$)/gi;
  let arquivo: RegExpExecArray | null;
  while ((arquivo = arquivos.exec(recibo[1])) !== null) nomes.push(arquivo[1]);
  if (nomes.length === 0 || nomes.join(", ") !== recibo[1]) return undefined;
  const mensagem = texto.slice(0, recibo.index);

  return (
    <>
      {mensagem && <Typography className="interview-chat-message" variant="body2" sx={{ mb: 1 }}>{renderTextoComNegrito(mensagem)}</Typography>}
      <Box component="ul" aria-label="Arquivos enviados" sx={{ m: 0, p: 0, listStyle: "none" }}>
        {nomes.map((nome, indice) => {
          const extensao = nome.split(".").pop()!.toLowerCase() as keyof typeof formatos;
          const { Icone, rotulo, cor } = formatos[extensao];
          return (
            <Box component="li" key={indice} sx={{ display: "flex", alignItems: "flex-start", gap: 1, py: 0.5 }}>
              <Icone titleAccess={rotulo} fontSize="small" sx={{ color: cor, flexShrink: 0 }} />
              <Typography component="span" variant="body2" sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
                {nome}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </>
  );
}
